module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pgmonospaced"
  }, [_c('br', {
    staticClass: "calibre1"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('div', {
    staticClass: "illo",
    attrs: {
      "id": "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "illo",
    attrs: {
      "id": "illo1"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "page102",
      "title": "102"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "calibre2",
    attrs: {
      "alt": "A man dangles the head of a 'boy' which has wires coming out of its neck.",
      "src": "OEBPS/Images/%40public%40vhost%40g%40gutenberg%40html%40files%4032032%4032032-h%40images%40illo1-sm.jpg"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre2 pcalibre1"
  }, [_vm._v("Left side image")]), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre2 pcalibre1"
  }, [_vm._v("Right side image")])]), _vm._v(" "), _c('h1', {
    staticClass: "calibre3",
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre4 pcalibre2 pcalibre1",
    attrs: {
      "id": "page103",
      "title": "103"
    }
  }), _vm._v("SECOND VARIETY")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4",
    attrs: {
      "id": "author"
    }
  }, [_vm._v("BY PHILIP K. DICK")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b4f454","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section0001.vue
// module id = 57
// module chunks = 0